import DepartmentTree from './DepartmentTree';

export default DepartmentTree